import React from 'react';
import PropTypes from 'prop-types';

export default function StarIcon(props) {
  return (
    <svg width={props.size || 24} height={props.size || 24} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path fillRule='evenodd' clipRule='evenodd' d='m11.5245,2.96352c0.1496,-0.46065 0.8014,-0.46065 0.951,0.00001l1.8819,5.79179c0.0669,0.20601 0.2589,0.34549 0.4755,0.34549l6.0899,0c0.4843,0 0.6857,0.61981 0.2939,0.90451l-4.9268,3.57948c-0.1753,0.1274 -0.2486,0.3531 -0.1817,0.5591l1.8819,5.7918c0.1497,0.4606 -0.3776,0.8437 -0.7694,0.559l-4.9268,-3.5795c-0.1753,-0.1274 -0.4125,-0.1274 -0.5878,0l-4.92679,3.5795c-0.39186,0.2847 -0.9191,-0.0984 -0.76942,-0.559l1.88187,-5.7918c0.06694,-0.206 -0.00639,-0.4317 -0.18164,-0.5591l-4.92679,-3.57948c-0.39186,-0.2847 -0.19047,-0.90451 0.29389,-0.90451l6.08986,0c0.21661,0 0.40859,-0.13948 0.47552,-0.34549l1.8819,-5.7918z' color={props.color} stroke={props.stroke} strokeWidth={props.strokeWidth} fill={props.fill} />
    </svg>
  );
}

StarIcon.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  height: PropTypes.number,
  size: PropTypes.number,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

StarIcon.defaultProps = {
  color: '#FFF',
  fill: 'none',
  stroke: '#FFF',
  strokeWidth: 2
};